// Languages come as "<language> - <level>" ("Anglais - Courant"), one level per language.

// "Anglais - Courant" -> "Anglais"
export const languageGroup = (name) => String(name ?? "").split(" - ")[0].trim();

const LEVEL_ORDER = ["débutant", "intermédiaire", "courant"];
const levelRank = (name) => {
    const level = String(name ?? "").split(" - ")[1]?.trim().toLowerCase() ?? "";
    const rank = LEVEL_ORDER.indexOf(level);
    return rank === -1 ? LEVEL_ORDER.length : rank;
};

// By language name, then by level from beginner to fluent (alphabetical would put "Courant" first).
export const compareLanguages = (a, b) =>
    languageGroup(a).localeCompare(languageGroup(b), "fr", { sensitivity: "base" }) || levelRank(a) - levelRank(b);
